<template>
    <div class="registerList-wrap">

      <Modal
        class="registerList "
        width="1300"
        :closable="false"
        footer-hide
        :mask-closable="false"
        v-model="parameter">
        <div slot="header">
          <p class="header-title">诊间转约</p>
        </div>

        <div>

          <Row>
            <Col span="2"  class="left-nav-register">
              <div :class="'nav-title ' + (funcShow===0 ?  'active' : '')" @click="funcShow=0">线下转诊</div>
              <div :class="'nav-title ' + (funcShow===1 ?  'active' : '')" @click="funcShow=1">取消就诊</div>
            </Col>

            <Col span="22"  class="right-content">
                <div class="content-register" v-if="funcShow==0">
                  <div>
                    <Form ref="formInline" :model="formInline" inline>

                      <FormItem label="科室" class="departments-li-form">
                        <Cascader
                          size="small"
                          filterable
                          :data="departmentsLi"
                          v-model="formInline.depHisId"
                          @on-change="depSelectHandler"></Cascader>
                      </FormItem>

                      <FormItem label="医生">
                        <Select
                            v-model="formInline.doctorHisGuid"
                            size="small"
                            filterable
                            :label-in-value="true"
                            @on-change="selectDoctor"
                            @on-query-change="getoctor"
                            style="width: 200px">
                            <Option
                              v-for="item in doctorList"
                              :value="item.doctorHisGuid"
                              :key="item.doctorHisGuid"
                              :ref="item.doctorHisGuid"
                              :id="item.doctorGuid"
                              >{{item.name}}</Option>
                        </Select>
                                         
                      </FormItem>

                      <FormItem label="日期">
                        <DatePicker size="small" disabled type="daterange" :value="[formInline.timeFrom, formInline.timeTo]" split-panels placeholder="请选择日期"></DatePicker>
                      </FormItem>

                      <FormItem>
                        <Button class="search-btn" type="primary" size="small" @click="searchSubmit">搜索</Button>
                      </FormItem>
                    </Form>
                  </div>
                  <p class="dep-name-p">{{sourceInfo.depName}}</p>
                  <div  v-if="sourceNoList.length>0">
                    <div class="col-list-box">
                      <div class="col-list col-list-doctor">
                        <p class="title-table-time">医生</p>
                        <div class="doctor-name-table">
                          <span>{{sourceInfo.doctorName}}</span>
                        </div>
                      </div>
                      <div class="col-list" v-for="(item,index) in sourceNoList" :key="index">
                        <p class="title-table-time">{{item.data}}</p>

                        <p  v-for="(items,indexs) in item.timeSlotList"
                          :key="indexs"
                          :class="'slot-time '+ (items.num>0 ? 'highlight' : 'disabled')+ (activeSlot==(indexs +''+index) ? ' active': '')"
                          @click="selectTime(items,indexs +''+index)">
                          <span class="solt-time-show">{{items.slot}}</span>
                        </p>

                      </div>
                    </div>

                    
                  </div>

                  <div class="col-list-box" v-else>
                      <p class="result-list">未能找到您想查找的内容</p>
                  </div>

                </div>
                <div class="content-register" v-if="funcShow===1">
                  <p>请填写本次取消就诊的原因</p>
                  <Input
                    v-model="cancelReason"
                    class="reason-input"
                    type="textarea"
                    :maxlength="400"
                    show-word-limit
                    :autosize="{minRows: 5,maxRows: 10}"/>
                  
                </div>

            </Col>
          </Row>
        </div>
         <div class="record-footer">
            <Button class="search-btn" type="primary" v-if="funcShow==0"  @click="handleSubmit">确认转诊</Button>
            <Button class="search-btn" type="primary" v-if="funcShow===1"  @click="cancelAppointment">确定</Button>

            <Button @click="handlerCancle">取消</Button>
        </div>
      </Modal>

      <Modal
        v-model="modalCancle"
        @on-ok="cancleOK">
        <p>是否继续取消本次就诊，继续后将原路退还患者线上的预约费用</p>
    </Modal>

    </div>
</template>

<script>
import { api } from '@/services'
import { mapGetters } from 'vuex'
import { fmtDate } from '@/utils/tool'
export default {
  name: 'recordModel',
  props: {
    parameter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      imMeaage: '',
      // 取消就诊的弹窗
      modalCancle: false,
      // modalShow: true,
      // 0 线下转诊  1取消转诊
      funcShow: 0,
      // 取消转诊的原因
      cancelReason: '',
      // 参数
      formInline: {
        depHisId: [],
        doctorHisGuid: '',
        timeFrom: '',
        timeTo: ''
      },
      // 科室列表
      departmentsLi: [],
      // 医生列表
      doctorList: [],
      // 页面显示 科室名称 和医生名称
      sourceInfo: {
        doctorName: '',
        depName: '',
        depId: '',
        doctorGuid: '',
        type: null
      },
      activeSlot: null,
      // 号源列表
      sourceNoList: [],
      appointmentParameter: {}
    }
  },

  created: function () {
    this.getDepList()
    this.initDate()
  },
  methods: {
    ...mapGetters({
      headerUserRest: 'prvateConsultation/headerUserRest'
    }),
   
    // 默认日期
    initDate () {
      let nexday = new Date().getTime() + 7 * 24 * 60 * 60 * 1000
      let today = fmtDate(new Date(), 'yyyy-MM-dd')
      let nexdays = fmtDate(new Date(nexday), 'yyyy-MM-dd')
      this.formInline.timeFrom = today
      this.formInline.timeTo = nexdays
    },
    // 获取列表科室
    getDepList () {
      api.depListSourceNo({
        data: {
          params: {}
        }
      })
        .then(res => {
          this.departmentsLi = res.data.list
        })
    },
    // 选择完科室后回调
    depSelectHandler (value, selectedData) {
      this.sourceInfo.depName = selectedData[1].label || selectedData[0].label
      this.sourceInfo.depId = selectedData[1].id || selectedData[0].label
      this.getoctor('')
    },
    // 获取医生列表
    getoctor (query) {
      api.doctorListSourceNo({
        data: {
          params: {
            deptId: this.sourceInfo.depId,
            searchKey: query
          }
        }
      })
        .then(res => {
          this.doctorList = []
          this.doctorList = JSON.parse(JSON.stringify(res.data.list))

        })
    },
    // 选择医生
    selectDoctor (item) {
      if(item){
        this.sourceInfo.doctorName = item.label
        this.sourceInfo.doctorGuid = this.$refs[item.value][0].$attrs.id
      
      }
     
    },
    selectTime (item, indexNum) {
      // .class = (this.$refs['id-' + id].class + ' active')
      this.activeSlot = indexNum
      this.appointmentParameter = item
    },
    searchSubmit () {
      // debugger
      let deptId = this.formInline.depHisId[1] || this.formInline.depHisId[0]

      if (!deptId || !this.formInline.doctorHisGuid) {
        this.$Message.warning('请输入搜索内容')
        return false
      }
      this.sourceNoList = []
      api.searchSourceNo({
        data: {
          params: {
            timeFrom: this.formInline.timeFrom,
            timeTo: this.formInline.timeTo,
            depHisId: deptId,
            doctorHisGuid: this.formInline.doctorHisGuid
          }
        }
      })
        .then(res => {
          this.sourceInfo.type = res.data.type
          this.sourceNoList = res.data.list
        })
    },
    // 取消转诊
    cancelAppointment () {
      // 请填写取消本次就诊的原因
      if (!this.cancelReason) {
        this.$Message.warning('请填写取消本次就诊的原因')
        return false
      }
      this.modalCancle = true
    },
    handlerCancle () {
      console.log(1)
      this.$emit('handlermodalCancel', {
        parameter: false
      })
    },
    // 取消线下转诊
    cancleOK () {
      api.offlineReferralCancel({
        data: {
          params: {
            'orderId': this.$store.state.prvateConsultation.headerUserRest.orderId,
            'cancelReason': this.cancelReason
          }
        }
      })
        .then(res => {
          if (res.code === 0) {
            // 发送消息给患者
            this.imMessge = res.data.message
            this.$Message.success('取消预约成功')
            
            this.handlerMessage()
          }
          this.handlerCancle()
        })
    },
    // 转诊预约
    handleSubmit () {
      // let res = {
      //   data: {
      //     message: '111111'
      //   }
      // }
      // this.imMessge = res.data.message
      // // this.$Message.success('预约成功')
      // // this.handlerCancle()
      // this.handlerMessage()

      // return false
      api.offlineReferralAppointmentCreate({
        data: {
          params: {
            'orderId': this.$store.state.prvateConsultation.headerUserRest.orderId,
            'card_id': '',
            'deptIdFromHIS': '',
            'doctor_guid': this.sourceInfo.doctorGuid,
            'startTime': this.appointmentParameter.slot.split('-')[0],
            'endTime': this.appointmentParameter.slot.split('-')[1],
            'infoId': this.appointmentParameter.dynamicScheduleInfoId,
            ...this.appointmentParameter,
            'timeSlotSeq': this.appointmentParameter.time_slot

          }
        }
      })
        .then(res => {
          if (res.code === 0) {
            this.imMessge = res.data.message

            this.$Message.success('预约成功')
            
            this.handlerMessage()
          }
          this.handlerCancle()
        })
    },
    handlerMessage () {
      this.$emit('handlerMessage', this.imMessge)
    }
  }
}

</script>

<style>
.registerList{
  min-height: 800px;
}
.ivu-modal{
  width: 80% !important;
}
.registerList .ivu-modal-header{
  background: #72beff;
  color: #fff;
}
.registerList .ivu-modal-body{
  padding: 0 !important;
}
.registerList .ivu-modal-header p{
  color: #fff !important;
}
.registerList .nav-title{
  text-align: center;
  line-height: 1.5rem;
  font-size: 0.28rem;
  cursor: pointer;
}
.registerList .nav-title.active{
  background: #ebebeb;

}
.right-content{
  padding: 10px;

}
.col-list-box{
  height: 100%;
  display: flex;
  margin: 0.5rem 0;
}
.col-list-box .title-table-time{
  background: #E6F3FF;
  color: #333333;
  line-height: 1rem;
  text-align: center;
}
.col-list-doctor{
  position: relative;
  width: 2rem !important;
  flex: inherit;
}
.col-list-box .doctor-name-table{
  font-size: 0.3rem;
  position: absolute;
  bottom: 0;
  top: 1rem;
  text-align: center;
  width: 100%;
  Justify-content:center;
  align-items:center;
  display:-webkit-flex;

}

.content-register .col-list-box .col-list{
  margin: 0 0.05rem;
  display: inline-block;
  vertical-align: top;
  /* flex: 1; */
  border: 1px solid #72beff;
  border-radius: 0.1rem;
  overflow: hidden;
  width: 2.5rem;
  text-align: center;
  -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;

}
.slot-time{
  font-size: 0.3rem;
  line-height: 1rem;
  border-top: 1px solid #72beff;
  cursor: pointer;
}
.slot-time.disabled{
  background: #F2F2F2;
  color: #999999;
}
.slot-time.highlight:hover{
  background: #E6F3FF;
}

.slot-time.highlight.active{
   background: #72beff;
   color: #fff;
}
/* 搜索 */
.registerList .ivu-form-item-content{
  display: inline-block;
  vertical-align: middle;
}
.departments-li-form .ivu-form-item-content{
  margin-top: 0.17rem;
}
.search-btn{
  background: #72beff;
  border: none;
}
.result-list{
  text-align: center;
  width: 100%;
}
/* 搜索结束 */

/* 取消就诊 */
.reason-input{
  margin: 20px 0;
  width: 600px;
}
.btn-box-register{
  text-align: center;
}
.record-footer{
  padding: 0.3rem 0;
  /* border-top: 1px solid #e2e2e2; */
}
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/fun_right/changeRegistration/index.vue